module.exports = "/_next/static/images/589a4859b3ae8170f4598a945467fd33-aboutus-xpeer.jpg";